// extracted by mini-css-extract-plugin
export var select = "_o5-0";